import type { Province } from '../../types/province';

/**
 * SF-165 Component 4: extracted from `RazePanel.tsx` (its inline copy carried a comment noting it
 * was itself already a port of `computeRazeCostPerAcre` from a now-deleted `Raze.tsx` page —
 * porting it a third time into `MobileRazePanel.tsx` would have made it a third hand-copy of the
 * same lineage. Single source of truth for both the desktop and mobile Raze panels.
 */
export function computeRazeCostPerAcre(province: Province): number {
  const totalLand = province.territory.totals.acres;
  const baseBuildCost = (2 / 31) * (totalLand + 11600);

  // Race modifier (Dwarf = 0, others = 1.0)
  const raceMod = province.metadata.race === 'DWARF' ? 0 : 1.0;

  // Personality modifier (Shepherd = 0.7, others = 1.0)
  const personalityMod = province.metadata.personality === 'SHEPHERD' ? 0.7 : 1.0;

  // Mills modifier
  const millsRatio = (province.territory.buildings.MILL || 0) / totalLand;
  const buildingEfficiency = province.economy.buildingEfficiency || 1.0;
  const millsMod = 1 - millsRatio * buildingEfficiency * 0.75;

  const buildCost = baseBuildCost * raceMod * personalityMod * millsMod;
  return Math.round(buildCost / 2);
}
